import { removeInvalidOptions } from '../../field-viewer/shared-normalizers';
export const imageChoiceViewer = {
    normalizeLoadedValue: removeInvalidOptions
};

//# sourceMappingURL=definition-viewer.js.map